import axios from 'components/Axios';
import { Education } from '../APIEndPoint';

const AddEducation = (payload) => {
  const promise = axios.post(`${Education}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const UpdateEducation = (payload, id) => {
  const promise = axios.put(`${Education}/${id}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetEducationById = () => {
  const getUsername = window.location.pathname.split('/');
  const currentUsername = getUsername?.[getUsername?.length - 1]?.trim()
  const promise = axios.get(`${Education}/byUserName/${currentUsername}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const DeleteEducation = (id) => {
  const promise = axios.delete(`${Education}/${id}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export { AddEducation, UpdateEducation, GetEducationById, DeleteEducation };
